export default __webpack_public_path__ + "static/media/question-mark-card.be8106da.png";